import { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import Layouts from "../pages/Layouts";



// import ProcessesList from '../pages/ProcessesList';
// TODO: check component name

const ProcessesList = lazy(() => import("../pages/ProcessesList"));
const EventList = lazy(() => import("../pages/EventList"));
const ReportsList = lazy(() => import("../pages/ReportsList"));
const TasksList = lazy(() => import("../pages/TasksList"));
const CallActivityAssociate = lazy(
  () => import("../pages/CallActivityAssociate")
);
const SingleInstance = lazy(() => import("../pages/ProcessInstance/SingleInstance"));
const HistoryInstances = lazy(() => import("../pages/ProcessInstance/HistoryInstances"));
const SingleInitiate = lazy(() => import("../pages/InitiateProcess/SingInitiate"));
const BulkInitiate = lazy(() => import("../pages/InitiateProcess/BulkInitiate"));
const SingleAssociate = lazy(() => import("../pages/Associate/SingleAssociate"));
const BulkAssociate = lazy(() => import("../pages/Associate/BulkAssociate"));
const MyTask = lazy(() => import("../pages/MyTask"));
const AutoTemplateListPage = lazy(() => import("../pages/Process/autoTemplate"));
const EditAutoTemplate = lazy(() => import("../pages/Process/autoTemplate/EditAutoTemplate"));
const ViewAutoTemplate = lazy(() => import("../pages/Process/autoTemplate/ViewAutoTemplate"));
const TaskManager = lazy(() => import("../pages/Process/taskManager"));
const TaskForm = lazy(
  () => import("../pages/Process/taskManager/userTask/TaskForm")
);
const SystemTaskForm = lazy(
  () => import("../pages/Process/taskManager/systemTask/TaskForm")
);
const TaskPropertyList = lazy(
  () => import("../pages/Process/taskManager/TaskPropertyList")
);
const TemplateManagerListPage = lazy(
  () => import("../pages/Process/templateManager")
);
const AddTemplateManager = lazy(
  () => import("../pages/Process/templateManager/AddTemplateManager")
);
const AddTemplateBPMN = lazy(
  () => import("../pages/Process/templateManager/AddTemplateBPMN")
);
const NotificationPage = lazy(() => import("../pages/Notification"));
const TestPostMessage = lazy(() => import("../pages/TestPostMessage"));
const TestEventManager = lazy(() => import("../pages/TestEventManager"));
const PerformTask = lazy(() => import("../pages/Process/performTask"));

const planTrackRouter = [
  {
    path: "/plantrack",
    element: <Layouts />,
    children: [
      {
        path: "processeslist",
        element: <ProcessesList />,
      },
      {
        path: "eventlist",
        element: <EventList />,
      },
      {
        path: "reportslist",
        element: <ReportsList />,
      },
      {
        path: "taskslist",
        element: <TasksList />,
      },
    ],
  },
  {
    path: "/process",
    element: <Layouts />,
    children: [
      {
        path: "associate",
        element: <SingleAssociate />,
      },
      {
        path: "bulk-associate",
        element: <BulkAssociate />,
      },
      {
        path: "call-activity-associate",
        element: <CallActivityAssociate />,
      },
      {
        path: "initiate",
        element: <SingleInitiate />,
      },
      {
        path: "bulk-initiate",
        element: <BulkInitiate />,
      },
      {
        path: "history",
        element: <HistoryInstances />,
      },
      {
        path: "perform-task/:taskId",
        element: <PerformTask />,
      },
      {
        path: ":processAssociationId",
        element: <SingleInstance />,
      },
    ],
  },
    {
    path: "/mytask",
    element: <Layouts />,
    children: [
      {
        path: "",
        element: <MyTask />,
      }
    ],
  },
  {
    path: "/notification",
    element: <Layouts />,
    children: [
      {
        path: "",
        element: <NotificationPage />,
      },
    ],
  },
  {
    path: "/test-post-message",
    element: <Layouts />,
    children: [
      {
        path: "",
        element: <TestPostMessage />,
      },
    ],
  },
  {
    path: "/test-event-manager",
    element: <Layouts />,
    children: [
      {
        path: "",
        element: <TestEventManager />,
      },
    ],
  },
  {
    path: "/*",
    element: <Navigate to="/plantrack/processeslist" />,
  },
  {
    path: "/bpmn",
    element: <Layouts />,
    children: [
      {
        path: "",
        element: <Navigate to="task-manager" />,
      },
      {
        path: "task-manager",
        element: <TaskManager />,
      },
      {
        path: "task-manager/add-task",
        element: <TaskForm />,
      },
      {
        path: "task-manager/add-system-task",
        element: <SystemTaskForm />,
      },
      {
        path: "task-manager/edit-task/:taskId",
        element: <TaskForm />,
      },
      {
        path: "task-manager/edit-system-task/:taskId",
        element: <SystemTaskForm />,
      },
      {
        path: "task-manager/user-tasks/:taskId/properties",
        element: <TaskPropertyList taskType="user" />,
      },
      {
        path: "task-manager/service-tasks/:taskId/properties",
        element: <TaskPropertyList taskType="service" />,
      },
      {
        path: "template-manager",
        element: <TemplateManagerListPage />,
      },
      {
        path: "template-manager/edit-template-manager/:templateId",
        element: <AddTemplateManager />,
      },
      {
        path: "template-manager/add-template-manager",
        element: <AddTemplateManager />,
      },
      {
        path: "template-manager/add-template-bpmn/:templateId",
        element: <AddTemplateBPMN />,
      },
      {
        path: "template-manager/edit-template-bpmn/:templateId",
        element: <AddTemplateBPMN isEdit />,
      },
      {
        path: "auto-launcher",
        element: <AutoTemplateListPage />,
      },
      {
        path: "auto-launcher/edit/:recordId",
        element: <EditAutoTemplate />,
      },
      {
        path: "auto-launcher/view/:recordId",
        element: <ViewAutoTemplate />,
      }
    ],
  },

  // {
  //   path: "/testplantrack",
  //   element: <TestProcesses />,
  // },
];

const Router = createBrowserRouter(planTrackRouter);
export { Router };
